import { render, staticRenderFns } from "./PrivacyAsterika.vue?vue&type=template&id=715380f6"
import script from "./PrivacyAsterika.vue?vue&type=script&lang=js"
export * from "./PrivacyAsterika.vue?vue&type=script&lang=js"
import style0 from "./PrivacyAsterika.vue?vue&type=style&index=0&id=715380f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports